import React, { useMemo } from "react";
import { IProcessedOrders } from "./constants";
import { OrderListHeaders } from "./OrderList/OrderListViewHeaders";
import { columns as newOrderColumn } from './Columns/NewOrders.columns'
import Styles from "../../scss/orderHistory.module.scss";
import { OrderListView } from "./OrderList/OrderListView";
import { OrderPickupTitles } from "./OrderList/OrderPickupTitle";
import { IEmptyMessages } from "./OrderList/OrderList";
import { OrderListFinishAllButton } from "./OrderList/OrderListFinishAllButton";
import { makeStyles } from "@material-ui/styles";
import { ICollectionPoint } from "../ordersSetting/Forms/CollectionPointEntity";
import { MarkReadyButton } from "./OrderActionButtons/MarkReadyButton";

interface IPickupListContainerProps {
    orderList: IProcessedOrders[];
    openOrderDialog: (item: IProcessedOrders) => void;
    emptyMessageObject?: IEmptyMessages;
    collectionPoints: ICollectionPoint[];
}

const useStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: "1rem"
    }
});
export function PickupListContainer({
    orderList,
    openOrderDialog,
    emptyMessageObject,
    collectionPoints
}: IPickupListContainerProps) {
    const { root } = useStyles();
    const { accepted, readyForCollection } = useMemo(() => {
        const readyForCollection = [];
        const accepted = [];
        for (const item of orderList) {
            if (item.order_status === "ACCEPTED") {
                accepted.push(item);
            } else if (item.order_status === "READY_FOR_COLLECTION") {
                readyForCollection.push(item);
            }
        }
        return {
            accepted,
            readyForCollection
        }
    }, [orderList]);
    const { acceptedHeight, collectionHeight } = useMemo(() => {
        const collectionHeight = (readyForCollection.length * 80) + 125
        const acceptedHeight = (accepted.length * 80) + 125;
        return {
            acceptedHeight,
            collectionHeight
        }
    }, [accepted, readyForCollection]);

    function renderCollectionOrders() {
        return <> <div key={`columnHeaders-collection-accepted}`} className={Styles.columnsHeader}>
            {newOrderColumn.map((column) => <OrderListHeaders {...column} key={`col-collection-accepted-${column.key}-${column.label}`} />)}
        </div>
            <OrderListView heightOverride={acceptedHeight} orderList={accepted} columns={newOrderColumn} openOrderDialog={openOrderDialog} emptyMessageObject={emptyMessageObject}/>
        </>
    }

    return <div>
        <div className={root}>
            <OrderPickupTitles label="forms.orders.pickup.inProgress" value={accepted.length} />
            <MarkReadyButton collectionPoints={collectionPoints}
                orderList={accepted} disabled={accepted.length === 0} />
        </div>
        {renderCollectionOrders()}
        <div className={root}>
            <OrderPickupTitles label="forms.orders.pickup.readyForCollect" value={readyForCollection.length} />
            <OrderListFinishAllButton orderList={readyForCollection} disabled={readyForCollection.length === 0} />
        </div>

        <div key={`columnHeaders-collection-ready-for-collection}`} className={Styles.columnsHeader}>
            {newOrderColumn.map((column) => <OrderListHeaders {...column} key={`col-collection-ready-for-collection-${column.key}-${column.label}`} />)}
        </div>
        <OrderListView heightOverride={collectionHeight} orderList={readyForCollection} columns={newOrderColumn} openOrderDialog={openOrderDialog} emptyMessageObject={{ ...emptyMessageObject, info: "order.emptyList.readyCollectionInfo" }}  orderListType={"Ready_For_Collection"}/>
    </div >
}